var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "feed-back-c" }, [
    _c(
      "a",
      {
        staticClass: "feed-back",
        attrs: { href: _vm.feedbackUrl, target: "_blank" },
        on: { click: _vm.handleClick },
      },
      [
        _c("img", {
          staticClass: "fb-icon",
          attrs: { src: require("../images/icon_Feedback_fd@2x.png") },
        }),
        _vm._v(" "),
        _vm._m(0),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tooltip-c" }, [
      _c("div", { staticClass: "side-sohu-tooltip" }, [_vm._v("举报/反馈")]),
      _vm._v(" "),
      _c("div", { staticClass: "side-sohu-three" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }